import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string; // 페이지 설명 추가
  image?: string; // 페이지의 대표 이미지 URL 추가
  url?: string; // 페이지 URL 추가
}

const SEO = ({
  title, description, image, url,
}: SEOProps) => (
  <HelmetProvider>
    <Helmet>
      <title>
        {title ? `STEAMuP Academy | ${title}` : 'STEAMuP Academy'}
      </title>
      <link rel="shortcut icon" href="/assets/images/favicon.ico" />
      <link rel="stylesheet" href="/assets/css/loader.css" />
      {/* TODO: 확인 필요 - 추가적인 메타태그들  */}
      {description && <meta name="description" content={description} />}
      {description && <meta property="og:description" content={description} />}
      {image && <meta name="image" content={image} />}
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
    </Helmet>
  </HelmetProvider>
);

export default SEO;
